import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import progressStorage from 'core/progressStorage';
import { INDEX_PATH } from 'constants/navigation';
import { RootAppState } from 'store/types';
import { isLoaderVisibility } from 'store/loader/selectors';

type RouteWithRedirectProps = {
  component: any;
  shouldRedirect: boolean;
  isLoaderVisible?: boolean;
  history?: { [key: string]: any };
  exact: any;
  path: any;
};
export const RouteWithRedirect = ({
  component: Component,
  shouldRedirect,
  isLoaderVisible,
  ...rest
}: RouteWithRedirectProps) => (
  <Route
    {...rest}
    render={props => {
      const routeTo = progressStorage.url || INDEX_PATH;
      const canRedirect = props.history.location.pathname !== routeTo;
      if (shouldRedirect && canRedirect) {
        return <Redirect to={routeTo} />;
      }
      if (!isLoaderVisible) {
        return <Component {...props} />;
      }
      return <></>;
    }}
  />
);

function mapStateToProps(state: RootAppState) {
  return {
    isLoaderVisible: isLoaderVisibility(state)
  };
}
export default connect(mapStateToProps)(RouteWithRedirect);
